import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { travelItineraryUrl, travelAuthorUrl, TRAVELTYPE, BOOKINGTYPE, BOOKINGMETHOD, PURPOSE} from 'src/app/modules/shared/common/api';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';
import { AddressService } from '../../services/address/address.service';

@Component({
  selector: 'app-travel-itinerary-view',
  templateUrl: './travel-itinerary-view.component.html',
  styleUrls: ['./travel-itinerary-view.component.scss']
})
export class TravelItineraryViewComponent implements OnInit {

  _user: User;
  travel: Travel;
  formGroup: FormGroup;
  loading:boolean = false;
  isBook:boolean = false;
  isCharged:boolean = false;
  isCurrency:boolean = false;
  displayForm:boolean = false;
  doneTransaction:boolean = false;
  show:boolean = false;
  successMessage: String = '';
  pipe = new DatePipe('en-US');
  bookingDetails = [];

  travelOption = ["Individual","Group"];
  purposeOption = PURPOSE;
  natureOption = ["Inbound","Outbound"];
  departmentList:any;
  positionList:any;
  expensesList:any;
  itineraryId:any;

  currencyOption = [
    {id:1,name:"PHP"},
    {id:2,name:"USD"},
    {id:3,name:"Others"}
  ];
  chargeOption = [
    {id:1,name:"Rose Pharmacy"},
    {id:2,name:"DF"},
    {id:3,name:"Supplier"},
    {id:4,name:"RRHI"},
    {id:5,name:"Southstar Drug"}
  ];
  billOption = ["Store Support Center","Requestor"];

  bookedOption = BOOKINGTYPE;
  bookedMethod = BOOKINGMETHOD;
  travelType = TRAVELTYPE;

  dialogConfig:any;
  detail:any;
  fDate: any;
  tDate: any;
  currentDate: any;
  displayDate: boolean = false;
  isCreate: boolean = false;
  selectedIndex = 0;
  total = 0;
  mealTotal = 0;
  objArray = [];
  arr: FormArray;

  constructor(
    public dialogRef: MatDialogRef<TravelItineraryViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelService: TravelService,
    public auth: AuthService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public address: AddressService,
  ) {
    
   }

  ngOnInit() {
    this._user = new User(this.auth.getAuthUser());
    this.formGroup = this.formBuilder.group({
      date_filed:['',null],
      itinerary_date: ['',null],
      travel_authorization_no: ['',null],
      travel_authorization_id: ['',null],
      complete_name:['',null],
      employee_id_no: ['',null],
      position: ['',null],
      department: ['',null],
      area_covered: ['',null],
      payroll_acct_no: ['',null],
      travel_type: ['',null],
      copy_date: ['',null],
      purpose: ['',null],
      location: ['',null],
      nature: ['',null],
      inclusive_date_from: ['',null],
      inclusive_date_to: ['',null],
      representation:['',null],
      miscellaneous:['',null],
      currency: ['',null],
      amount: ['',null],
      charged_to: ['',null],
      booked_by: ['',null],
      bill_to: ['',null],
      is_draft: ['',null],
      accommodation_cost: ['',null],
      currency_category: ['',null],
      charged_to_category: ['',null],
      total_transportation_cost:['',null],
      travel_itinerary_details:['',null],
      is_lunch:['',null],
      is_dinner:['',null],
      booking_type_itinerary:['',null],
      booking_method:['',null],
      is_breakfast: ['',null],
      meal:['',null],
      per_diem:['',null],
      itinerary_miscellaneous: this.formBuilder.array([]),
    });

    this.currentDate = this.data.res.itinerary_date;
    this.formGroup.controls['itinerary_date'].setValue(this.data.res.itinerary_date);
    this.formGroup.controls['total_transportation_cost'].setValue(this.data.res.total_transportation_cost);
    this.formGroup.controls['area_covered'].setValue(this.data.res.area_covered);
    this.formGroup.controls['bill_to'].setValue(this.data.res.bill_to);
    this.formGroup.controls['accommodation_cost'].setValue(this.data.res.accommodation_cost);
    this.formGroup.controls['per_diem'].setValue(this.data.res.per_diem);
    this.formGroup.controls['meal'].setValue(this.data.res.meal);
    this.formGroup.controls['representation'].setValue(this.data.res.representation);
    this.formGroup.controls['miscellaneous'].setValue(this.data.res.miscellaneous);
    this.formGroup.controls['is_lunch'].setValue(this.data.res.is_lunch);
    this.formGroup.controls['is_dinner'].setValue(this.data.res.is_dinner);
    this.formGroup.controls['is_breakfast'].setValue(this.data.res.is_breakfast);
    this.formGroup.controls['payroll_acct_no'].setValue(this.data.res.payroll_acct_no);
    this.formGroup.controls['booked_by'].setValue(this.data.res.booked_by);
    this.formGroup.controls['charged_to'].setValue(this.data.res.charged_to);
    this.formGroup.controls['currency'].setValue(this.data.res.currency);
    this.formGroup.controls['currency_category'].setValue(this.data.res.currency_category);
    this.formGroup.controls['charged_to_category'].setValue(this.data.res.charged_to_category);
    this.formGroup.controls['inclusive_date_from'].setValue(this.data.resinclusive_date_from);
    this.formGroup.controls['inclusive_date_to'].setValue(this.data.res.inclusive_date_to);
    this.formGroup.controls['location'].setValue(this.data.res.location);
    this.formGroup.controls['nature'].setValue(this.data.res.nature);
    this.formGroup.controls['purpose'].setValue(this.data.res.purpose);
    this.formGroup.controls['travel_type'].setValue(this.data.res.travel_type);
    this.formGroup.controls['travel_authorization_id'].setValue(this.data.res.id);
    this.formGroup.controls['travel_itinerary_details'].setValue(this.data.res.travel_itinerary_details);
    this.expensesList = this.data.res.travel_itinerary_details;
    this.itineraryId = this.data.res.id;

    this.formGroup.controls['booking_type_itinerary'].setValue(this.data.res.booking_type);
    this.formGroup.controls['booking_method'].setValue(this.data.res.booking_method);

    this.expensesList.forEach(element => {
      element.travel_itinerary_bookings.forEach(el => {
        this.bookingDetails.push(el);
        this.isBook = true;
      });
    });

    this.formGroup.controls['employee_id_no'].setValue(this._user.employee_id);
    this.detail = this.data.res;

    this.travel = new Travel(this.data.res);
    this.travel.formGroup = this.formGroup;
    
    this.travel.totalExpenses = this.data.res.total_expense;
    this.travel.disableForm();

    this.show = this.data.displayEdit;
    if (this.show) {
      this.travel.enableForm();
    }

    
    this.address.getMisc().subscribe(res => {
      this.arr = this.formGroup.get('itinerary_miscellaneous') as FormArray;
      res.forEach((element,i) => {
        this.objArray.push({
          name: element.name,
          miscellaneous_id: element.id,
          amount: 0,
        });

        let amountVal =  (this.data.res.itinerary_miscellaneous[i])? this.data.res.itinerary_miscellaneous[i].amount : 0 ;
        this.arr.push(this.formBuilder.group({
            name: [element.name,null],
            miscellaneous_id: [element.id,null],
            amount: [{value: amountVal, disabled: true}  ,null],
          }));
      });

    });

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';

    //accommodation logic
    this.formGroup.get('booking_type_itinerary').valueChanges.subscribe(value => {
      if (value.toLowerCase() == "office" && this.formGroup.get('booking_method').value.toLowerCase() == "book only") {
        this.formGroup.controls['accommodation_cost'].enable();
      } else if (value.toLowerCase() == "self" && this.formGroup.get('booking_method').value.toLowerCase() == "book and pay"){
        this.formGroup.controls['accommodation_cost'].enable();
      } else {
        this.formGroup.controls['accommodation_cost'].setValue(0);
        this.formGroup.controls['accommodation_cost'].disable();
      }
    });

    //accommodation logic
    this.formGroup.get('booking_method').valueChanges.subscribe(value => {
      if (value.toLowerCase() == "book only" && this.formGroup.get('booking_type_itinerary').value.toLowerCase() == "office") {
        this.formGroup.controls['accommodation_cost'].enable();
      } else if (value.toLowerCase() == "book and pay" && this.formGroup.get('booking_type_itinerary').value.toLowerCase() == "self"){
        this.formGroup.controls['accommodation_cost'].enable();
      } else {
        this.formGroup.controls['accommodation_cost'].setValue(0);
        this.formGroup.controls['accommodation_cost'].disable();
      }
    });
  }

  closeOnClick() {
    this.dialogRef.close();
  }

  mealvalue(e,i) {

    switch (i) {
      case 1:
        this.formGroup.controls['is_breakfast'].setValue((i == 1 && e.checked)? 1 : 0 );
        break;
      case 2:
        this.formGroup.controls['is_lunch'].setValue((i == 2  && e.checked)? 1 : 0 );
        break;
      case 3:
        this.formGroup.controls['is_dinner'].setValue((i == 3  && e.checked)? 1 : 0 );
      break;
      default:
        break;
    }

    if (e.checked) {
      this.mealTotal = this.mealTotal + 100;
      this.total += 100; 
    } else {
      this.total -= 100;
      this.mealTotal -= 100; 
    }

    this.formGroup.controls['meal'].setValue(this.mealTotal);

  }

  /**
   * Save Itinerary
   */
  save() {
    this.loading = true;
    this.travelService.updateItinerary(this.itineraryId,this.formGroup.value).subscribe(res=>{
      this.loading = false;
      this.dialogRef.close(this.formGroup.value);
    },(err =>{
      this.loading = false;
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
    }));
  }

  onChangeStartDate(e) {
    this.fDate = this.pipe.transform(e.value, 'yyyy-MM-dd');
  }

  onChangeEndDate(e) {
    this.tDate = this.pipe.transform(e.value, 'yyyy-MM-dd');
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g); // '\d'
     return pattern.test(e.key);
  }  

  /**
   * Delete summary list
   * @param i = index in the list
   */
  deleteSummary(i) {
    this.removeRow(i,this.travel.summary_list);
  }
  
  /**
   * Remove in Object Array
   * @param index index key
   * @param data list
   */
  removeRow(index,data){
    data.splice(index, 1);
  }

  clear() {
    this.formGroup.controls['itinerary_date'].setValue('');
    this.formGroup.controls['accommodation_cost'].setValue('');
    this.formGroup.controls['booked_by'].setValue('');
    this.formGroup.controls['bill_to'].setValue('');
    this.formGroup.controls['representation'].setValue('');
    this.formGroup.controls['miscellaneous'].setValue('');
    this.formGroup.controls['per_diem'].setValue('');
    this.formGroup.controls['meal'].setValue('');
    this.formGroup.controls['is_breakfast'].setValue('');
    this.formGroup.controls['is_lunch'].setValue('');
    this.formGroup.controls['is_dinner'].setValue('');
    this.mealTotal = 0;
  }

  countDays() {
    var diff = Math.abs(this.fDate.getTime() - this.tDate.getTime());
    return Math.ceil(diff / (1000 * 3600 * 24)); 
  }

  incrementDates(dateString) {
    var result = new Date(new Date(dateString).setDate(new Date(dateString).getDate() + 1));
    return result.toISOString().substr(0, 10);
  }


}
